import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../components";

const mapStateToProps = (state) => {
    return {
        isAuthorized: state.isAuthorized
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));